import { Component, OnInit } from '@angular/core';
import {AuthService, UserData} from '../../auth.service';
import {ActivatedRoute, Router} from '@angular/router';
import {AlertService} from '../../alert.service';
import Swiper from '../../../assets/libs/swiper-4.5.0/swiper-4.5.0/dist/js/swiper.min';

@Component({
  selector: 'app-main',
  templateUrl: './main.component.html',
  styleUrls: ['./main.component.sass']
})
export class MainComponent implements OnInit {

  today: Date = new Date()
  user: firebase.User;
  message: string;
  users: UserData[];
  swiper: Swiper;

  constructor(
    private auth: AuthService,
    private route: ActivatedRoute,
    public alert: AlertService,
    private router: Router) {
  }

  ngOnInit() {
    this.auth.getUserState()
      .subscribe(user => {
        this.user = user;
        if (!this.user) {
          this.router.navigate(['/login'], {
            queryParams: {
              loginAgain: true
            }
          });
        }
      });
    this.swiper = new Swiper('.main_slider', {
      slidesPerView: 1,
      spaceBetween: 0,
      freeMode: false,
      loop: false,
      pagination: {
        el: '.main_slider .swiper-pagination',
        clickable: true
      }
    });
    this.swiper = new Swiper('.news_slider', {
      slidesPerView: 'auto',
      spaceBetween: 20,
      freeMode: false,
      loop: false,
      pagination: {
        el: '.news_slider .swiper-pagination',
        clickable: true
      },
      breakpoints: {
        1200: {
          slidesPerView: 'auto',
          spaceBetween: 15
        }
      }
    });
  }

}
